import { GoBoxStyled } from '@OnArk/styles/Boxes.styled';
import { ChurchButtonStyled } from '@OnArk/styles/Buttons.styled';
import { TextStyled, TitleStyled } from '@OnArk/styles/Text.styled';

import React from 'react';

import { MaxWidthStyled } from '@hangar31/rc-layout';
import withAuth from 'graphql/withAuth';
import withClient from 'graphql/withClient';
import Link from 'next/link';

import Icon from '@OnArk/SVGs/Icon';

function ChurchCourseDirectory({ church }: ChurchCourseDirectoryPageProps) {
  return (
    <div css={{ marginBottom: '20vh' }}>
      <TitleStyled>Class Directory</TitleStyled>
      <MaxWidthStyled grid>
        {church.courses.map(course => (
          <GoBoxStyled key={course.id}>
            <h1>
              {course.name}
              <span>
                <ChurchButtonStyled
                  as={Link}
                  bottom="1.5"
                  href={`/${church.url}/${course.url}`}
                  inline
                  top="1.5"
                >
                  Go
                </ChurchButtonStyled>
                <Icon name="ARROWS_Right" right="0" size="20" />
              </span>
            </h1>
            {course.description &&
              course.description.replace(/<\/?[a-zA-Z]+>/gm, '') && (
                <TextStyled
                  dangerouslySetInnerHTML={{ __html: course.description || '' }}
                />
              )}
          </GoBoxStyled>
        ))}
      </MaxWidthStyled>
    </div>
  );
}

export type ChurchCourseDirectoryPageProps = ServerSidePagePropsWithClient<
  typeof getServerSideProps
>;
export const getServerSideProps = withAuth(async ({ client, params }) => {
  const { church } = await client.getChurchByUrl({
    churchUrl: params?.['church.url'] as string,
    date: new Date(),
  });

  if (!church) return { notFound: true };

  return {
    props: {
      church: church,
      layout: 'GUEST',
      pageTitle: church?.name + ' | OnArk',
    },
  };
}, 'PUBLIC');

export default withClient(ChurchCourseDirectory);
